import { ArticleSectionIC } from '@/lib/interface-types';
import uuid from 'react-uuid';
import ArticleLanding from '../article/article-landing';

const SectionLanding = ({ section, subCategory }: ArticleSectionIC) => {
  const { items } = section.sectionContentCollection || {};

  return (
    <section className="SectionLanding w-full">
      <h3>{section.title}</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3  mt-8 xl:grid xl:grid-cols-1">
        {items?.map((article: any, index: any) => (
          <ArticleLanding
            key={uuid()}
            article={article}
            classIndex={index}
            sectionLayout={section.layout}
            subCategory={subCategory}
          />
        ))}
      </div>
    </section>
  );
};

export default SectionLanding;
